import { IoArchive, IoBusiness, IoCamera, IoCreateOutline, IoHome, IoPencilOutline, IoPerson, IoSettings } from "react-icons/io5";

import { IoCheckmarkCircleSharp, IoCloseCircleSharp } from "react-icons/io5";
import moment from "moment";
import { Button, Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { isMobile } from "../../utils/helpers";
import { useState } from "react";

const TRANSITION_STATUS = {
    WAITING_PHOTOGRAPHER: 'In attesa del fotografo',
    WAITING_EDITOR: 'Da assegnare',
    AUTOMATIC_ASSIGN: 'Assegna in automatico',
    DONE: 'Completato',
    IN_PROGRESS: 'In lavorazione',
    COMPLETED: 'Completato',
    CANCELLED: 'Annullato'
};

function ActionButtons({
    task,
    index,
    handleOnSave,
    size,
    appointment,
    order_item,
    selectedEditorName,
    hasDifferentStatus
}) {
    const navigate = useNavigate();
    const [showConfirm, setShowConfirm] = useState(false);

    const motivi = [
        "Il materiale è stato controllato",
        "Le note sono state verificate",
        "Il cliente può ricevere il materiale"
    ];

    const { product } = order_item;
    const { poll } = order_item;
    const { order } = order_item;
    const { organization } = order;
    const { building } = appointment || {};

    const handleApproveSend = () => {
        setShowConfirm(true);
    };

    const handleConfirm = () => {
        setShowConfirm(false);
        handleOnSave(index);
    };

    const handleClose = () => setShowConfirm(false);

    return <>
        <Button
            className={`btn-${size} my-1 fw-600 ${task.needSave ? 'blinking-element' : ''} ${task.status === 'WAITING_PHOTOGRAPHER' ? 'disabled' : ''}`}
            variant="primary"
            onClick={handleApproveSend}
        >
            AGGIORNA
        </Button>
        {task.order_item.product.type === 'RENDER' && <Button
            className={`btn-${size} my-1 fw-600`}
            variant="light"
            onClick={() => navigate(`/render-manage/${task.order_item.order.id}`)}
        >
            VISUALIZZA
        </Button>}
        <Offcanvas
            show={showConfirm}
            onHide={handleClose}
            placement="bottom"
            className="action-sheet"
        >
            <Offcanvas.Body>
                <div className="section mt-3 text-center">
                    <h2>Conferma aggiornamento stato</h2>
                    <p>Sei sicuro di voler aggiornare stato o quantità di questo servizio?</p>
                    <ul className="text-start" style={{ maxWidth: 400, margin: "0 auto" }}>
                        <li>{organization.display_name}</li>
                        {appointment?.building?.owner_last_name &&<li>{appointment?.building?.owner_last_name}</li>}
                        {building && <li>{`${building.address.full} - RIF ${building?.reference}`}</li>}
                        <li>
                            {product.type === 'RENDER' ? 'Rendering ' : ''}
                            {product.description}<br />
                            {order_item.is_priority == true && <span className='text-warning'>({product.priority_label})</span>}
                        </li>
                        <li>  Quantità: {task.quantity || '0'}</li>
                        {hasDifferentStatus && <li>  Valore Status: {selectedEditorName ? selectedEditorName : TRANSITION_STATUS[task.status] }</li>}
                    </ul>
                    <div className="d-flex gap-2 justify-content-center mt-3">
                        <Button variant="secondary" onClick={handleClose}>Annulla</Button>
                        <Button variant="primary" onClick={handleConfirm}>Conferma e invia</Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    </>;
}

function OffCanvasOpen({
    task,
    handleOnSave
}) {
    
    return <>
        <Offcanvas
            placement="bottom"
            className="action-sheet"
            show={true}
            onHide={()=>{}} 
        ></Offcanvas>
    </>
}

export default function PostProductionRow({
    index,
    task,
    staff,
    handleChange,
    handleOnSave,
}) {
    const { order_item } = task;
    const { product } = order_item;
    const { poll } = order_item;
    const { order } = order_item;
    const { organization } = order;
    const { appointment } = order;
    const { building } = appointment || {};
    const [selectedEditorName, setSelectedEditorName] = useState('');
    const [hasDifferentStatus, setHasDifferentStatus] = useState(false);

    if (isMobile()) {
        return (
            <tr style={{ borderBottom: '14px solid #121212' }}>
                <td colSpan="11">
                    <div className="text-start">
                        <div>
                            <h3 className='mb-05'>{moment(appointment?.estimated_start_at ?? task.created_at).format('DD/MM/YYYY - HH:mm')} {building ? `| RIF. ${building?.reference}` : ''}</h3>
                            <div className="text-14">
                                <IoBusiness className="vertical-align-n2" />{' '}
                                {organization.display_name}
                            </div>
                        </div>
                        <div className='text-15'>
                            <ul className="listview image-listview no-border no-after bg-272727">
                                {building?.address && <li>
                                    <div className="item px-0">
                                        <div className="in">
                                            <div>
                                                <header><IoHome className="vertical-align-n2" /> Dettagli immobile:</header>
                                                <div className='mb-05'>{building?.address.full}</div>
                                                <b>Proprietario:</b> {building?.owner_last_name} {building?.owner_first_name}<br />
                                                <b>Fotografo:</b> {staff.p[appointment?.photographer_id]}
                                            </div>
                                        </div>
                                    </div>
                                </li>}
                                <li>
                                    <div className="item pt-0 px-0">
                                        <div className="in">
                                            <div>
                                                <header><IoCamera className="vertical-align-n2" /> Servizio:</header>
                                                {product.type === 'RENDER' ? 'Rendering ' : ''} {product.description} {order_item.is_priority == true && <span className='text-warning'>({product.priority_label})</span>}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                {(task.status !== 'WAITING_PHOTOGRAPHER' || (task.note_in || poll.is_social_post)) && <li>
                                    <div className="item pt-0 px-0">
                                        <div className="in">
                                            <div className="flex-fill">
                                                <header><IoPerson className="vertical-align-n2" /> {product.edit_action	 === 'MATTERPORT' ? 'Link matterport' : 'Note fotografo:'}</header>
                                                {poll.is_social_post ? 'Da pubblicare sui social' : ''}<br />
                                                <div className="form-group boxed pb-0">
                                                    <div className="input-wrapper m-0">
                                                        <textarea 
                                                            rows="2" 
                                                            className="form-control" 
                                                            onChange={(e) => handleChange(e, index)}
                                                            name="note_in"
                                                            id={`task_${task.id}_note_in`}
                                                            value={task.note_in || ''}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>}
                                {(task.note_out) && <li>
                                    <div className="item pt-0 px-0">
                                        <div className="in">
                                            <div>
                                                <header><IoPerson className="vertical-align-n2" /> Note editor:</header>
                                                {task.note_out}
                                            </div>
                                        </div>
                                    </div>
                                </li>}
                                {appointment ? <li>
                                    <div className="item pt-0 px-0">
                                        <div className="in">
                                            <div className="flex-fill">
                                                <header><IoArchive className="vertical-align-n2" /> Quantità:</header>
                                                <div className="form-group boxed pb-0">
                                                    <div className="input-wrapper m-0">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            style={{ background: '#3a3a3a' }}
                                                            id={`task_${task.id}_quantity`}
                                                            placeholder='Numero materiale'
                                                            name="quantity"
                                                            value={task.quantity || ''}
                                                            onChange={(e) => handleChange(e, index)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li> : ''}
                                <li>
                                    <div className="item pt-0 px-0">
                                        <div className="in">
                                            <div className="flex-fill">
                                                <header><IoSettings className="vertical-align-n2" /> Stato:</header>
                                                <div className="form-group boxed text-center">
                                                    <div className="input-wrapper">
                                                        <select
                                                            className="form-control form-select"
                                                            style={{ backgroundColor: '#3a3a3a' }}
                                                            id={`task_${task.id}_status`}
                                                            name="status"
                                                            value={task.status === 'WAITING_EDITOR' && !!task.editor_id ? `${task.status}:${task.editor_id}` : task.status}
                                                            onChange={e => {handleChange(e, index);}}
                                                            >
                                                            <option value="WAITING_PHOTOGRAPHER">Da caricare</option>
                                                            <option value="WAITING_EDITOR">Da assegnare</option>
                                                            <option value="AUTOMATIC_ASSIGN">Assegna in automatico ✨</option>
                                                            <optgroup label="Assegnato a:">
                                                                {staff.e.map(user => (
                                                                    <option
                                                                        key={user.uid}
                                                                        value={`WAITING_EDITOR:${user.editor.id}`}
                                                                        disabled={!product.edit_action ? false : !user.editor[`can_edit_${product.edit_action.toLowerCase()}`]}
                                                                    >
                                                                        {user.display_name}
                                                                    </option>
                                                                ))}
                                                            </optgroup>
                                                            <option value="DONE">
                                                                {task.status === 'DONE' ? `${task.date_out ? moment(task.date_out).format('DD/MM HH:mm') : ''}${task.editor_id ? ` (${(staff.e.find(u => u.editor.id === task.editor_id)?.display_name ?? 'Editor cancellato')})`: ''} - ` : ''} Completato
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ActionButtons 
                                task={task}
                                index={index}
                                handleOnSave={handleOnSave}
                                size='block'
                                appointment={appointment}
                                product={product}
                                order_item={order_item}
                                selectedEditorName={selectedEditorName}
                            />
                        </div>
                    </div>
                </td>
                <Offcanvas
                    task={task}
                    handleOnSave={handleOnSave}
                />
            </tr>
        );
    }

    const note = product.edit_action === 'MATTERPORT' ? `Matterport: ${task.note_in ? 'inserito' : 'DA INSERIRE'}` : (`${task.note_in ? `F: ${task.note_in}` : ''}${task.note_out ? `\nE: ${task.note_out}` : ''}`);
    const note_td = note.substring(0, 100) + (note.lenght > 100 ? '...' : '');
    const handleEditNote = () => {
        const note_new = window.prompt('Modifica nota', (task.note_in ?? ''));
        if (note_new === null) return;  
        handleChange({ target: { name: 'note_in', value: note_new } }, index);
    };

    return (
        <tr>
            {/* data */}
            <td>{moment(appointment?.estimated_start_at ?? task.created_at).format('DD/MM/YYYY HH:mm')}</td> 
            {/* photographer */}
            <td>{staff.p[appointment?.photographer_id]}</td>
            {/* cliente */}
            <td>{organization.display_name}</td>
            {/* proprietario */}
            <td>{building?.owner_last_name ? `${building?.owner_last_name} ${building?.owner_first_name}` : ``}</td>
            {/* immobile */}
            <td><b>{building ? `${building.address.full} - RIF ${building?.reference ? building.reference : appointment?.description}` : ''}</b></td>
            {/* servizio */}
            <td>
                {product.type === 'RENDER' ? 'Rendering ' : ''}
                {product.description}<br />
                {order_item.is_priority == true && <span className='text-warning'>({product.priority_label})</span>}
            </td>

            {/* social */}
            <td>
                <span className={`iconedbox text-${poll.is_social_post ? 'success' : 'danger'}`}>
                    {!appointment ? '' : (poll.is_social_post ? <IoCheckmarkCircleSharp /> : <IoCloseCircleSharp />)}
                </span>
            </td>

            {/* note */}
            <td title={note}>{note_td}<IoCreateOutline className="cursor-pointer mx-2" onClick={handleEditNote}/></td>

            {/* quantity */}
            <td>
                {appointment ? <div className="form-group boxed p-0 text-center">
                    <div className="input-wrapper m-0">
                        <input
                            type="number"
                            className="form-control text-center px-2 m-auto"
                            style={{ background: '#3a3a3a', width: '70px' }}
                            id={`task_${task.id}_quantity`}
                            name="quantity"
                            value={task.quantity || ''}
                            onChange={(e) => handleChange(e, index)}
                        />
                    </div>
                </div> : ''}
            </td>
            {/* status */}
            <td>
                <div className="form-group boxed text-center">
                    <div className="input-wrapper">
                        <select
                            className="form-control form-select"
                            style={{ backgroundColor: '#3a3a3a', minWidth: '150px' }}
                            id={`task_${task.id}_status`}
                            name="status"
                            value={task.status === 'WAITING_EDITOR' && !!task.editor_id ? `${task.status}:${task.editor_id}` : task.status}
                            onChange={(e) => {
                                setHasDifferentStatus(true);
                                const val = e.target.value;
                                if (val.startsWith('WAITING_EDITOR:')) {

                                    const editorId = Number(val.split(':')[1]);
                                    const editor = staff.e.find(u => u.editor.id === editorId);
                                    if(editor){
                                        setSelectedEditorName(editor ? editor.display_name : '');
                                    }
                                } else {
                                    setSelectedEditorName('');
                                }
                                handleChange(e, index);
                            }
                            }
                        >
                            <option value="WAITING_PHOTOGRAPHER">Da caricare</option>
                            <option value="WAITING_EDITOR">Da assegnare</option>
                            <option value="AUTOMATIC_ASSIGN">Assegna in automatico ✨</option>
                            <optgroup label="Assegnato a:">
                                {staff.e.map(user => (
                                    <option
                                        key={user.uid}
                                        value={`WAITING_EDITOR:${user.editor.id}`}
                                        disabled={!product.edit_action ? false : !user.editor[`can_edit_${product.edit_action.toLowerCase()}`]}
                                    >
                                        {user.display_name}
                                    </option>
                                ))}
                            </optgroup>
                            <option value="DONE">
                                {task.status === 'DONE' ? `${task.date_out ? moment(task.date_out).format('DD/MM HH:mm') : ''}${task.editor_id ? ` (${(staff.e.find(u => u.editor.id === task.editor_id)?.display_name ?? 'Editor cancellato')})`: ''} - ` : ''} Completato
                            </option>
                        </select>
                    </div>
                </div>
            </td>
            <td>
                <ActionButtons 
                    task={task}
                    index={index}
                    handleOnSave={handleOnSave}
                    size='sm'
                    appointment={appointment}
                    order_item={order_item}
                    selectedEditorName={selectedEditorName}
                    hasDifferentStatus={hasDifferentStatus}
                />
            </td>
        </tr>
        
    );
}
